module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h1-part"
  }, [_c('a', {
    attrs: {
      "id": "part01"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("PART ONE")])])]), _c('a', {
    attrs: {
      "id": "part01"
    }
  }, [_c('h1', {
    staticClass: "h1title"
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("The Clouded Levels")])]), _vm._v(" "), _c('p', {
    staticClass: "block"
  }, [_vm._v("If there are gods, they do not help, and justice belongs to the strong: but know that all things done before the naked stars are remembered.")]), _vm._v(" "), _c('p', {
    staticClass: "attrb"
  }, [_vm._v("—Klingon proverb")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a2b3892","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part01.vue
// module id = 81
// module chunks = 0